import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { Text } from '@/components/shared/components/Text';

export const businessNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'business_name',
    headerName: <Text tId={'BUSINESS_NAME'} />,
    renderCell: (rowData: PayoutsListRowProps) => (
      <div className="shorted-cell simple-select overflow-text-ellipsis">
        <div style={{ minWidth: '120px' }}>{rowData.row.businessName}</div>
      </div>
    ),
  };
};
